import React, { useEffect, useState } from "react";
import { Dialog, Slide } from "@mui/material";
import axiosClient from "../../axios";

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});

const AllPartnersModal = ({ open, onClose, month }) => {
	const [partners, setPartners] = useState([]);
	const [loading, setLoading] = useState(false);

	const formatCurrency = (amount) => {
		return new Intl.NumberFormat('en-US', {
			style: 'currency',
			currency: 'USD',
			minimumFractionDigits: 0,
			maximumFractionDigits: 0
		}).format(amount || 0);
	};

	const getVarianceIcon = (acceptable) => {
		return acceptable ? (
			<span style={{ color: "var(--success-color)", fontSize: "16px" }}>✓</span>
		) : (
			<span style={{ color: "var(--warning-color)", fontSize: "16px" }}>⚠</span>
		);
	};

	useEffect(() => {
		if (open) {
			fetchAllPartners();
		}
	}, [open, month]);

	const fetchAllPartners = () => {
		setLoading(true);
		axiosClient
			.get(`/admin/all-partners?month=${month}`)
			.then((res) => {
				setPartners(res?.data?.response?.partners || []);
			})
			.catch((err) => {
				console.log("error fetching all partners", err);
				alert("Error fetching partners data");
			})
			.finally(() => {
				setLoading(false);
			});
	};

	return (
		<Dialog
			open={open}
			onClose={onClose}
			TransitionComponent={Transition}
			maxWidth="lg"
			fullWidth
		>
			<div className="dialog-content-v4" style={{ padding: "var(--spacing-xxl)" }}>
				<div style={{
					display: "flex",
					justifyContent: "space-between",
					alignItems: "center",
					marginBottom: "var(--spacing-xl)"
				}}>
					<h3 className="dialog-title-v4">All Partners - {month}</h3>
					<button className="cancel-button-v4" onClick={onClose}>Close</button>
				</div>

				{loading ? (
					<div className="loader-container-v4">
						<div className="loader-image-v4">📊</div>
						<p style={{ marginTop: "var(--spacing-md)", color: "var(--text-muted)" }}>
							Loading partners...
						</p>
					</div>
				) : partners.length > 0 ? (
					<div className="table-container-v4">
						<table className="data-table-v4">
							<thead>
								<tr>
									<th>Partner</th>
									<th>Our Revenue</th>
									<th>Partner Reported</th>
									<th>User Payout</th>
									<th>Margin</th>
									<th>Received</th>
									<th>Outstanding</th>
								</tr>
							</thead>
							<tbody>
								{partners.map((partner, index) => (
									<tr key={index}>
										<td>
											<div style={{ fontWeight: "600" }}>{partner.partnerName}</div>
											<div style={{ fontSize: "11px", color: "var(--text-muted)" }}>
												{partner.revenuePercentage}% of total
											</div>
										</td>
										<td>
											<div style={{ fontWeight: "600", color: "var(--success-color)" }}>
												{formatCurrency(partner.ourRevenueUSD)}
											</div>
										</td>
										<td>
											<div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
												{getVarianceIcon(partner.varianceAcceptable)}
												<span style={{ fontWeight: "600" }}>
													{formatCurrency(partner.partnerReportedUSD)}
												</span>
											</div>
											{partner.varianceUSD !== 0 && (
												<div style={{
													fontSize: "11px",
													color: partner.varianceUSD < 0 ? "var(--danger-color)" : "var(--success-color)"
												}}>
													{partner.varianceUSD > 0 ? '+' : ''}{formatCurrency(partner.varianceUSD)}
												</div>
											)}
										</td>
										<td>
											<div style={{ fontWeight: "600" }}>
												{formatCurrency(partner.userPayoutUSD)}
											</div>
											<div style={{ fontSize: "11px", color: "var(--text-muted)" }}>
												{partner.payoutRatio}% ratio
											</div>
										</td>
										<td>
											<div style={{ fontWeight: "600", color: "var(--primary-color)" }}>
												{formatCurrency(partner.marginUSD)}
											</div>
											<div style={{ fontSize: "11px", color: "var(--text-muted)" }}>
												{partner.marginPercentage}%
											</div>
										</td>
										<td>
											<div style={{ fontWeight: "600" }}>
												{formatCurrency(partner.receivedUSD)}
											</div>
											<div style={{ fontSize: "11px", color: "var(--text-muted)" }}>
												{partner.receivedPercentage}%
											</div>
										</td>
										<td>
											<div style={{ fontWeight: "600" }}>
												{formatCurrency(partner.outstandingUSD)}
											</div>
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				) : (
					<div className="empty-state-v4">
						<div className="empty-icon-v4">📭</div>
						<h3>No Partners Found</h3>
						<p>No partner data available for this month</p>
					</div>
				)}
			</div>
		</Dialog>
	);
};

export default AllPartnersModal;